import React from 'react'
import Avatar from '../../avatar/Avatar'
import AboutMenu from './AboutMenu'

const About = () => {
  return (
    <>
      <Avatar page='about' />
      <AboutMenu />
    </>
  )
}

export default About
